import { useEffect, useState } from "react";
import type { DashboardProject } from "../../../types/project";
import { SpecificationDocument } from "../../../types";
import { Specifications } from "../../../mocks/Specification";
import { useTeamMembers } from "../../../hooks/useTeamMembers";
import { DialogContent, Dialog, DialogContentWithoutClose } from "../../../../../components/ui/dialog";
import { ProductionTab } from "./tabs/ProductionTab";
import { ProductionTabV1 } from "./tabs/ProductionTabV1";

interface AssemblyProductionDashboardProps {
  project: DashboardProject;
  onBack: () => void;
  selectedAssembly: string | null;
  setSelectedAssembly: (assembly: string | null) => void;
  isOpen: boolean;
  onClose: () => void;
  materials: {
    pipes?: any[];
    forge?: any[];
    gas?: any[];
    wireLot?: any[];
    coating?: any[];
  };
  selectedPipe: any;
  selectedItem: any;
  canEdit?: boolean;
  canReport?: boolean;
  canSign?: boolean;
  isCustomerRepresentativeUser?: boolean;
  isQCInspectorUser?: boolean;
  isWelderUser?: boolean;
  currentUserTeamMemberId?: string | number;
  isAdminOrSuperAdmin?: boolean;
  refreshMaterials: () => void;
}

export const AssemblyProduction: React.FC<AssemblyProductionDashboardProps> = ({
  project,
  onBack,
  selectedAssembly,
  setSelectedAssembly,
  isOpen,
  onClose,
  materials,
  selectedPipe,
  selectedItem,
  canEdit = true,
  canReport = true,
  canSign = true,
  isCustomerRepresentativeUser = false,
  isQCInspectorUser = false,
  isWelderUser = false,
  currentUserTeamMemberId,
  isAdminOrSuperAdmin = false,
  refreshMaterials
}) => {
  const {
    teamMembers,
    selectedTeamMember,
  } = useTeamMembers();

  const [specifications, setSpecifications] = useState<SpecificationDocument[]>(Specifications);

  const [isQRScannerOpen, setIsQRScannerOpen] = useState(false);
  const [scanningFor, setScanningFor] = useState<'forge' | 'pipe' | null>(null);
  const [selectedPipeSize, setSelectedPipeSize] = useState<number>(0);

  useEffect(() => {

    if (selectedPipe?.documentsData?.documents && Array.isArray(selectedPipe.documentsData.documents)) {
      const newSpecifications: SpecificationDocument[] = selectedPipe.documentsData.documents.map((doc: any) => ({
        id: doc.docRefId?.toString(),
        fileName: doc.fileName || '',
        type: doc.type as SpecificationDocument['type'],
        pipeId: selectedPipe?.pipeId?.toString(),
        projectId: selectedPipe?.projectId,
        projectTypeId: selectedPipe?.projectTypeId,
        pipeOrder: selectedPipe?.pipeOrder || 0,
        fileUrl: doc.fileUrl,
        s3Key: doc.s3Key,
        uploadedBy: doc.uploadedBy,
        uploadDate: doc.uploadDate,
        version: doc.version || 1,
        details: doc.details || {},
        files: doc.files || [],
        docRefId: doc.docRefId || 0
      }));


      setSpecifications(newSpecifications);
    } else {
      // Use mock specifications when no documents data is available
    }
  }, [selectedPipe]);







  // const handleQRResult = (result: string) => {
  //   if (scanningFor === 'forge') {
  //     const forge = materials?.forge?.find((m: any) => 
  //       m.details?.forgeSerialNumber === result
  //     );
  //     if (forge) {
  //       setSelectedForgeId(forge.materialId);
  //     } else {
  //       toast.error('Invalid or unavailable forge QR code');
  //     }
  //   } else if (scanningFor === 'pipe') {
  //     const pipe = materials?.pipes?.find((m: any) => 
  //       m.details?.pipeNRI === result
  //     );
  //     if (pipe) {
  //       setSelectedPipeId(pipe.materialId);
  //     } else {
  //       toast.error('Invalid or unavailable pipe QR code');
  //     }
  //   }
  //   setIsQRScannerOpen(false);
  //   setScanningFor(null);
  // };

  // const handleQRScan = (type: 'forge' | 'pipe') => {
  //   setScanningFor(type);
  //   setIsQRScannerOpen(true);
  // };

  return (
    <div>
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContentWithoutClose className="max-w-[100vw] w-screen h-screen max-h-screen p-0 gap-0">
          {selectedPipe?.isReducerPipe ?

            (<ProductionTabV1
              specifications={specifications}
              materials={materials}
              selectedPipeSize={selectedPipeSize}
              selectedAssembly={selectedAssembly}
              setSelectedAssembly={setSelectedAssembly}
              onBack={onBack}
              selectedPipe={selectedPipe}
              selectedItem={selectedItem}
              project={project.project}
              canEdit={canEdit}
              canReport={canReport}
              canSign={canSign}
              isCustomerRepresentativeUser={isCustomerRepresentativeUser}
              isQCInspectorUser={isQCInspectorUser}
              isWelderUser={isWelderUser}
              currentUserTeamMemberId={currentUserTeamMemberId}
              isAdminOrSuperAdmin={isAdminOrSuperAdmin}
              refreshMaterials={refreshMaterials}
            />
            ) : (
              <ProductionTab
                specifications={specifications}
                materials={materials}
                selectedPipeSize={selectedPipeSize}
                selectedAssembly={selectedAssembly}
                setSelectedAssembly={setSelectedAssembly}
                onBack={onBack}
                selectedPipe={selectedPipe}
                selectedItem={selectedItem}
                project={project.project}
                canEdit={canEdit}
                canReport={canReport}
                canSign={canSign}
                isCustomerRepresentativeUser={isCustomerRepresentativeUser}
                isQCInspectorUser={isQCInspectorUser}
                isWelderUser={isWelderUser}
                currentUserTeamMemberId={currentUserTeamMemberId}
                isAdminOrSuperAdmin={isAdminOrSuperAdmin}
                refreshMaterials={refreshMaterials}
              />)
          }
        </DialogContentWithoutClose >
      </Dialog>

      {/* QR Scanner Dialog */}
      {/* {isQRScannerOpen && (
        <Dialog open={isQRScannerOpen} onOpenChange={setIsQRScannerOpen}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle>
                Scan QR Code for {scanningFor === 'forge' ? 'Forge' : 'Pipe'}
              </DialogTitle>
            </DialogHeader>
            <QRScanner onResult={handleQRResult} />
          </DialogContent>
        </Dialog>
      )} */}
    </div>
  );
};